export const NO_USER_PHOTO =
  'https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/system-images%2Favatar.jpg?alt=media&token=f219d025-f702-40cc-a0fd-c859bda0e199' // eslint-disable-line

export const DEFAULT_VENUE_IMAGE =
  'https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/system-images%2Fvenue.png?alt=media&token=1fdfec67-a3ef-46f6-957c-92e9f9919649' // eslint-disable-line

export const WATCHES_IMAGE =
  'https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/system-images%2Fwatches.png?alt=media&token=23a83f99-12f7-485c-9f20-0453201b8e38' // eslint-disable-line
